import { inject, Injectable } from '@angular/core';
import { catchError, throwError, map } from 'rxjs';
import { ApiService } from '@/core/services/api/api.service';
import {
  SaveUtilisateurDto,
  UpdateUtilisateurDto,
  Utilisateur,
  ChangerStatutDto,
  ChangerMotPasseUserDto,
  ChangerMotPasseAdminDto,
  UpdateCodeDto,
  UtilisateurByProfil,
} from '../interfaces/utilisateur.interface';
import { User, UserRole } from '@/core/models/user.model';
import { HttpParams } from '@angular/common/http';

/** Comptes utilisateurs : CRUD, statut, mot de passe, code, photo de profil. */
@Injectable({ providedIn: 'root' })
export class UtilisateurService {
  private readonly api = inject(ApiService);

  getUtilisateurs() {
    return this.api.get<{ data: Utilisateur[] }>('/users/all').pipe(
      map((res) => res.data),
      catchError((err) => throwError(() => err)),
    );
  }

  getUtilisateurById(id: number) {
    return this.api.get<{ data: Utilisateur }>(`/users/show_user/${id}`).pipe(
      map((res) => res.data),
      catchError((err) => throwError(() => err)),
    );
  }

  getUtilisateursByProfil(profilId?: number, codeProfils?: UserRole[]) {
    const params = new HttpParams()
      .set('profilId', profilId ?? '')
      .set('profils', codeProfils?.join(',') ?? '');
    return this.api.get<{ users: UtilisateurByProfil[] }>(`/users/parProfil`,params).pipe(
      map((res) => res.users),
      catchError((err) => throwError(() => err)),
    );
  }

  saveUtilisateur(data: SaveUtilisateurDto) {
    return this.api
      .post('/users/save_employe', data)
      .pipe(catchError((err) => throwError(() => err)));
  }

  updateUtilisateur(data: UpdateUtilisateurDto) {
    return this.api
      .put('/users/update_employe', data)
      .pipe(catchError((err) => throwError(() => err)));
  }

  uploadPhotoProfil(userId: number, file: File) {
    const fd = new FormData();
    fd.append('utilisateur', String(userId));
    fd.append('photo', file);
    return this.api
      .postFormData<{ photo: string }>('/users/upload_photo', fd)
      .pipe(catchError((err) => throwError(() => err)));
  }

  changerStatut(data: ChangerStatutDto) {
    return this.api
      .post('/users/activ_desactiv_employe', data)
      .pipe(catchError((err) => throwError(() => err)));
  }

  changerMotPasseUser(data: ChangerMotPasseUserDto) {
    return this.api
      .post('/users/change_password', data)
      .pipe(catchError((err) => throwError(() => err)));
  }

  changerMotPasseAdmin(data: ChangerMotPasseAdminDto) {
    return this.api
      .post('/users/changePwdAdmin', data)
      .pipe(catchError((err) => throwError(() => err)));
  }

  updateCode(data: UpdateCodeDto) {
    return this.api.post('/updateUserCode', data).pipe(catchError((err) => throwError(() => err)));
  }
}
